import styled from 'styled-components';

import Modal from 'components/library/layout/Modal';

export const StyledModal = styled(Modal)`
  .modal-body {
    overflow: visible !important;
  }
`;
